import React from 'react';
import './IframeModal.css';

interface IframeModalProps {
  isOpen: boolean;
  title: string;
  url: string;
  onClose: () => void;
}

const IframeModal: React.FC<IframeModalProps> = ({ isOpen, title, url, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="iframe-modal-backdrop" onClick={handleBackdropClick}>
      <div className="iframe-modal">
        <div className="iframe-modal-header">
          <h2 className="iframe-modal-title">{title}</h2>
          <button className="iframe-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="iframe-modal-content">
          <iframe
            src={url}
            title={title}
            className="iframe-modal-frame"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default IframeModal;